import { Injectable } from "@angular/core";
import { HttpClient, HttpBackend, HttpParams, HttpHeaders } from "@angular/common/http";
import { throwError, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ApiAnonymousService {
  private http: HttpClient;

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.apiUrl}${path}`, { params }).pipe(catchError(this.formatErrors));
  }

  put(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders().set("Content-Type", "application/json; charset=utf-8").set("Accept", "application/json");

    return this.http.put(`${environment.apiUrl}${path}`, JSON.stringify(body), { headers }).pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders().set("Content-Type", "application/json; charset=utf-8").set("Accept", "application/json");

    return this.http.post(`${environment.apiUrl}${path}`, JSON.stringify(body), { headers }).pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any) {
    return throwError(() => error.error);
  }
}
